module.exports = __webpack_public_path__ + "fde07342c2bda56af05c85c7703d1bf0.webp";